import { Link } from "react-router-dom";
import { navLinks, siteInfo, categories } from "@/mocks/manga";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold text-foreground-900 mb-4">
              {siteInfo.name}
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => ["guoman", "riman", "hanman", "rexue", "lianai", "xuanhuan"].includes(c.slug)).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">联系我们</h4>
            <p className="text-sm text-foreground-600 mb-2">
              <i className="ri-mail-line mr-2" />{siteInfo.email}
            </p>
            <p className="text-sm text-foreground-600 mb-2">
              <i className="ri-wechat-line mr-2" />微信：{siteInfo.wechat}
            </p>
            <p className="text-sm text-foreground-600">
              <i className="ri-qq-line mr-2" />QQ群：{siteInfo.qq}
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {siteInfo.year}-{new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}